import { render, staticRenderFns } from "./VsInput.vue?vue&type=template&id=10fb0576&lang=pug&"
import script from "./VsInput.vue?vue&type=script&lang=js&"
export * from "./VsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10fb0576')) {
      api.createRecord('10fb0576', component.options)
    } else {
      api.reload('10fb0576', component.options)
    }
    module.hot.accept("./VsInput.vue?vue&type=template&id=10fb0576&lang=pug&", function () {
      api.rerender('10fb0576', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/viralstyle-ui/src/VsInput.vue"
export default component.exports